/**
 * @generated SignedSource<<8b4118c85f32bc24a50764d83930a6bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type NameCell$data = {
  readonly avatar: {
    readonly medium: string | null | undefined;
  } | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly navigationMetadata: {
    readonly __typename: "JiraServiceManagementProjectNavigationMetadata";
    readonly __typename: "JiraServiceManagementProjectNavigationMetadata";
  } | {
    readonly __typename: "JiraSoftwareProjectNavigationMetadata";
    readonly boardId: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly projectId: string | null | undefined;
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly " $fragmentType": "NameCell";
};
export type NameCell$key = {
  readonly " $data"?: NameCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"NameCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NameCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "medium"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "LinkedField",
      "name": "navigationMetadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "boardId"
            }
          ],
          "type": "JiraSoftwareProjectNavigationMetadata"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c979112eb05ea526760f2c066b6f702c";

export default node;
